/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import { h } from 'preact'
import { useState } from 'preact/hooks'
import classNames from 'clsx'

import styles from './index.module.scss'

let COUNTER = 0

const Expandable = (props) => {
  const { className, height, style, ...rest } = props
  const [id] = useState(() => `expandable_${COUNTER++}`)
  const [open, setOpen] = useState(false)

  const computedStyle = height ?
    `--expandableHeight: ${height};${style || ''}` :
    style

  return (
    <div
      {...rest}
      style={computedStyle}
      className={classNames(
        className,
        styles['m-expandable'],
        { [styles['m-expandable--open']]: open },
      )}
      onChange={e => setOpen(e.target.checked)}
    >
      <input
        type="checkbox"
        id={id}
        checked={open}
        className={styles['m-expandable__checkbox']}
      />

      <div className={styles['m-expandable__content']}>
        {props.children}
      </div>

      <label
        htmlFor={id}
        role="button"
        className={styles['m-expandable__button']}
      >
        {/* eslint-disable-next-line react/jsx-no-literals */}
        {'expandir'}
      </label>
    </div>
  )
}

export default Expandable
